import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Typography,
  useTheme,
  useMediaQuery,
  SvgIcon
} from '@mui/material';
import { Menu as MenuIcon } from 'react-feather';

import Logo from 'src/components/Logo';
import { THEMES } from 'src/constants';
import Account from './Account';
import Search from './Search';
import Settings from './Settings';

function TopBar({ className, onMobileNavOpen, ...rest }) {
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));

  const dynamicStyles = {
    zIndex: theme.zIndex.drawer + 100,
    minHeight: 64,
    ...(theme.name === THEMES.DEFAULT && {
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.main
    }),
    ...(theme.name === THEMES.VIVSAC_BLUE && {
      backgroundColor: theme.palette.background.default
    })
  };

  return (
    <AppBar
      sx={dynamicStyles}
      className={className}
      {...rest}
    >
      <Toolbar sx={{ minHeight: 64 }}>
        {!isLgUp && (
          <IconButton
            color="inherit"
            onClick={onMobileNavOpen}
          >
            <SvgIcon fontSize="small">
              <MenuIcon />
            </SvgIcon>
          </IconButton>
        )}

        {isLgUp && (
          <RouterLink to="/">
            <Logo />
          </RouterLink>
        )}

        <Typography variant="h6" color="inherit" sx={{ ml: 2 }}>
          {/* Optional Title Here */}
        </Typography>

        <Box ml={2} flexGrow={1} />

        <Search />
        <Settings />
        <Box ml={2}>
          <Account />
        </Box>
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string,
  onMobileNavOpen: PropTypes.func
};

export default TopBar;
